import { variables } from '../variables';
import OnestBold from '../../fonts/GoldSilver/Onest-Bold.woff2';
import OnestMedium from '../../fonts/GoldSilver/Onest-Medium.woff2';
import OnestRegular from '../../fonts/GoldSilver/Onest-Regular.woff2';
import InstrumentSansBold from '../../fonts/GoldSilver/InstrumentSans-Bold.woff2';
import InstrumentSansRegular from '../../fonts/GoldSilver/InstrumentSans-Regular.woff2';
import InstrumentSansMedium from '../../fonts/GoldSilver/InstrumentSans-Medium.woff2';

export const goldSilverColors = {
  colorPrimary: '#1A4993', // GoldSilver Blue
  colorPrimaryLight: '#EFF6FC', // GoldSilver Tint
  colorPrimaryDark: '#051D37', // GoldSilver Shade
  colorBrandLight: '#fdb913', // GoldSilver Yellow
  colorWhite: '#ffffff',
  colorBlack: '#000000',
  colorRed: '#FF5028',
  colorGrey: '#EBECF2',
  colorGrey2: '#D9D9D9',
  colorGrey3: '#ADB1C7',
  colorGreenDarkOpacity: '#00B2990D',

  // Backgrounds
  colorBackgroundPrimary: '#ffffff',
  colorBackgroundSecondary: '#F8F9FA',
  colorWarningnBackground: '#FFECB5',

  // Typography Colors
  // Text
  colorTextPrimary: '#001739',
  colorTextSecondary: '#505575',
  colorTextContrast: '#ffffff',
  colorTextHeader: '#ffffff',
  colorTextLink: '#ffffff',
  colorTextOrange: '#A07610',

  colorSuccess: '#33BB5D',
  colorBadgeSuccess: 'rgba(51, 187, 93, 0.20)',
  colorError: '#FF5028',
  colorWarning: '#E2930A',
  colorIncomplete: '#212528',

  // Links
  colorLinkPrimary: '#1A4993',
  colorLinkRegistration: '#003246', // semiDark'

  // Button Colors
  colorButtonPrimary: '#1C4792',
  colorButtonPrimaryText: '#ffffff',
  colorButtonPrimaryHover: 'rgba(26, 73, 147, 0.9)',
  colorButtonPrimaryFocused: 'rgba(26, 73, 147, 0.9)',
  colorButtonPrimaryHoverText: '#ffffff',
  colorButtonOutlined: '#ffffff',
  colorButtonOutlinedBorder: '#1A4993',
  colorButtonOutlinedText: '#1A4993',
  colorButtonDisabled: 'rgba(26, 73, 147, 0.5)',

  colorButtonDefault: '#ffffff',
  colorButtonDefaultText: '#051D37',
  colorButtonDefaultBorder: '#051D37',
  colorButtonDefaultHover: '#8b8b8b',
  colorButtonAddNewBank: '#ffffff',

  // Input
  colorInputBorder: '#c4c4c4',
  colorInputBackground: '#ffffff',
  colorInputBorderFocused: '#555',
  colorInputBorderActive: '#c8c8c8',
  colorInputBackgroundDisabled: '#EBF2F2',
  colorInputText: '#555',
  colorInputPlaceholder: '#4E7A8C',
  colorInputSelectItemFocused: '#f4f4f4',

  // New input color - redesign
  colorInputBg: '#F5F5F5',

  // Label
  colorLabel: '#555',

  // Modal
  colorModalBackground: 'rgba(0, 0, 0, 0.3)',

  // Tabs
  colorTabBackground: '#ffffff',
  colorTabText: '#1A4993',
  colorTabSelectedBackground: '#1A4993',
  colorTabSelectedText: '#ffffff',

  // Pills
  colorPillsBackground: '#ffffff',
  colorPillsText: '#000',
  colorPillsBackgroundActive: '#1A4993',
  colorPillsTextActive: '#ffffff',

  // Filters
  colorFilterItemBackground: '#051D37',
  colorFilterItemText: '#ffffff',
  colorFilterIcon: '#ffffff',

  // Icons
  colorIconPrimary: '#051D37',
  colorIconSecondary: '#D89948',
  colorLoaderIcon: '#DCF2FD',

  // Radio Button
  colorRadioButton: '#003246',
  colorRadioButtonWrapperBorderSelected: '#D89948',

  // Tooltip
  colorTooltipBackground: '#051D37',
  colorTooltipText: '#ffffff',

  // Password Strength
  colorPasswordStrengthDefault: '#EBF2F2',
  colorPasswordStrengthWeak: '#FF5028',
  colorPasswordStrengthAverage: '#FDB942',
  colorPasswordStrengthGood: '#06BEE7',
  colorPasswordStrengthStrong: '#00876A',

  // Progress Bar Colors, Linear Gradient
  colorLinearGradientStart: '#1A4993',
  colorLinearGradientEnd: '#051D37',
  colorProgressBarDefault: '#F4F4F4',
  colorProgressBarFilled: '#D89948',

  // Header Colors
  colorMainHeaderBackground: '#051D37',
  colorSecondaryHeaderBackground: '#ffffff',
  colorHeaderLogoLight: '#ffffff',
  colorHeaderLogoDark: '#003246',

  // Navigation Colors
  colorNavigationItemHover: '#FDB913',

  // Navigation Dropdown Color
  colorNavigationDropdownBackground: '#051D37',
  colorNavigationDropdownItemHoverBackground: 'rgba(7, 44, 100, 0.5)',

  // Account Colors
  colorAccountBackground: '#020c17',
  colorAccountBorder: 'rgba(255,255,255, 0.2)',

  // Footer Colors
  colorFooterBackground: '#051D37',
  colorFooterText: '#dddddd',

  // Horizontal Break and Borders, Separators
  colorBorderPrimary: '#CCCFDE',
  colorBorderSecondary: '#D89948',

  // Table Colors
  colorTableHeaderBackground: '#f4f4f4',
  colorTableEvenRowBackground: '#fafafa',
  colorTableEvenRowHoverBackground: '#f4f4f4',
  colorTableSelectedBackground: 'rgba(226, 147, 10, 0.14)',
  colorHeadingRowItem: '#F0F5F6',

  // Shippment Status Colors
  colorShippmentSuccess: '#09846b',
  colorShippmentPending: '#E2930A',
  colorShippmentShipped: '#024f86',
  colorShippmentFailed: '#ff5028',

  // Address Status Colors
  colorVerifiedSuccess: '#09846b',
  colorNotVerified: '#8E8E8E',

  // Card Colors
  colorCardBackground: '#ffffff',
  colorCardSelected: 'rgba(226, 147, 10, 0.14)',
  colorCardBorder: '#EFF6FC',

  // Scrollbar Colors
  colorScrollbarBackground: '#c2c5c6',

  // MakeOver Banner
  colorMakeOverBannerBackground: '#f5f5f5',
  colorMakeOverBanner: '#003246',

  // Pending Banner
  colorPendingBannerBackground: '#f1f5f6',

  // Onboarding
  colorOnboardingBoxBorder: '#f3f3f3',
  colorOnboardingBoxBackground: 'rgba(196, 196, 196, 0.2)',
  colorOnboardingTextPrimary: '#ffffff',

  // Empty Box
  colorEmptyBoxTextPrimary: '#C2C5C6',

  // Graphic
  colorGraphicGridLines: '#ebeff2',

  // Info Banner
  colorInfoBannerBackground: '#003246',
  colorInfoBannerText: '#ffffff',

  // Auth card
  colorAuthCardSubtitle: 'rgb(0, 50, 70)',

  // Registration
  colorRegistration: '#1A4993',

  // Pie chart
  colorPieOne: '#003246',
  colorPieTwo: '#D89948',
  colorPieThree: '#4E7A8C',
  colorPieFour: '#808285',

  // Sidebar Gradients
  colorSidebarBegin: '#051D37',
  colorSidebarEnd: '#051D37',

  // Graph line
  colorGraphLine: '#FDB913',

  // Tags
  colorTag: '#FDB913',

  // Filters
  colorFilter: '#FDB913',

  // Add Button
  colorAddButton: '#FDB913',

  // Focus color
  colorFocus: '#505575',

  // Flag color
  colorFlag: '#179900',

  // Color note background
  colorNoteBackground: 'rgba(7, 44, 100, 0.1)',
};

export const goldSilverFonts = `
  @font-face {
    font-family: ${variables.family.goldSilver};
    src: url(${InstrumentSansBold}) format('woff2');
    font-weight: bold;
    font-style: normal;
    font-display: fallback;
  }

  @font-face {
    font-family: ${variables.family.goldSilver};
    src: url(${InstrumentSansMedium}) format('woff2');
    font-weight: 600;
    font-style: normal;
    font-display: fallback;
  }

  @font-face {
    font-family: ${variables.family.goldSilver};
    src: url(${InstrumentSansMedium}) format('woff2');
    font-weight: 500;
    font-style: normal;
    font-display: fallback;
  }

  @font-face {
    font-family: ${variables.family.goldSilver};
    src: url(${InstrumentSansRegular}) format('woff2');
    font-weight: 400;
    font-style: normal;
    font-display: fallback;
  }

  @font-face {
    font-family: ${variables.family.goldSilverHeaders};
    src: url(${OnestBold}) format('woff2');
    font-weight: bold;
    font-style: normal;
    font-display: fallback;
  }

  @font-face {
    font-family: ${variables.family.goldSilverHeaders};
    src: url(${OnestMedium}) format('woff2');
    font-weight: 600;
    font-style: normal;
    font-display: fallback;
  }

  @font-face {
    font-family:  ${variables.family.goldSilverHeaders};
    src: url(${OnestRegular}) format('woff2');
    font-weight: normal;
    font-style: normal;
    font-display: fallback;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  h1 *,
  h2 *,
  h3 *,
  h4 *,
  h5 *,
  h6 * {
  font-family: ${variables.family.goldSilverHeaders};
  font-weight: bold;
}

  *,
  *::after,
  *::before {
    font-family: ${variables.family.goldSilver};
  }
`;
